import { useEnvLabel } from "@/app/auth";
import { Code } from "@/ui";

// 卵石底上一个手写 A，路径与 public/favicon.svg 相同。favicon 随浏览器标签栏跟系统深浅色，后台还能手动切主题（D200），所以这里内联、取令牌颜色
const PEBBLE = "M31.7 16L31.6 20.4L31.3 22.7L30.9 24.6L30.2 26L29.3 27.3L28.3 28.3L27.1 29.1L25.8 29.8L24.2 30.3L22.4 30.7L20.2 30.9L16 31L11.8 31L9.5 30.8L7.7 30.4L6.2 29.8L5 29L3.9 28.1L3 27L2.3 25.7L1.7 24.2L1.3 22.5L1 20.2L0.8 16L0.8 11.7L0.9 9.4L1.2 7.5L1.7 5.8L2.4 4.5L3.3 3.3L4.5 2.4L5.9 1.7L7.5 1.3L9.4 1.1L11.8 1L16 1.1L20.1 1.4L22.3 1.7L24 2.2L25.4 2.7L26.7 3.3L27.9 4.1L28.9 5L29.8 6.2L30.6 7.6L31.2 9.3L31.5 11.6Z";
const STROKES = "M8.9 23.4L9 22.9L15 9.9L15.1 9.7L15.3 9.5L15.5 9.4L15.7 9.4L16 9.4L16.2 9.5L16.3 9.7L16.4 9.9L16.5 10.1L16.4 10.4L12.1 23.9L11.9 24.4L11.5 24.7L11.1 24.9L10.6 25L10.1 24.9L9.6 24.7L9.2 24.4L9 23.9ZM15.2 10.1L15.3 9.9L15.4 9.6L15.6 9.4L15.9 9.3L16.1 9.3L16.4 9.3L16.7 9.4L16.9 9.6L17 9.9L23.5 22.9L23.6 23.4L23.5 23.9L23.2 24.4L22.8 24.8L22.3 25.1L21.8 25.2L21.2 25.1L20.7 24.8L20.4 24.4L20.1 23.9L15.3 10.4Z";
const BAR = "M12.5 18.8C14.6 17.7 17.1 17.6 19.9 18.4";

/** 品牌图标。旁边有产品名时作装饰、不读出；单独出现时以 label 作名称。 */
function Logo({ label }: { label?: string }) {
  const a11y = label ? { role: "img", "aria-label": label } : { "aria-hidden": true };
  return (
    <svg width={22} height={22} viewBox="0 0 32 32" style={{ flex: "none" }} {...a11y}>
      <path d={PEBBLE} fill="var(--brand)" />
      <path d={STROKES} fill="var(--on-brand)" />
      <path d={BAR} fill="none" stroke="var(--on-brand)" strokeWidth={1.43} strokeLinecap="round" />
    </svg>
  );
}

/** 产品名与环境标记，侧栏顶部与登录页共用。 */
export function Brand() {
  const env = useEnvLabel();
  return <><Logo />Axon{env && <Code>{env}</Code>}</>;
}

/** 侧栏收成图标条时有环境标记就只留标记，区分生产与测试比产品名要紧；正式环境只留图标。完整名称在 title 或 aria-label。 */
export function BrandMark() {
  const env = useEnvLabel();
  return env ? <Code title={`Axon ${env}`}>{env}</Code> : <Logo label="Axon" />;
}
